import React from 'react'

function NoDataAvailable() {
  return (
    <div style={{textAlign: 'center'}}>Отсутствуют данные</div>
  )
}

export default NoDataAvailable